<template>
  <CommonLayout @reDrawMemoImage="reDrawMemoImage" header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :itemInfo="itemInfo" v-slot="slotProps" :inputFlg="!isSelectComplete && !isReDrawMemoImage && loginStatus['prodInst'] !== '1'" :singleFlg="!(suggestionType in styleSetSuggestionType)" :type="this.consts.meetingType.florist">
      <div class="base-color overflow-auto shadow">
        <b-overlay :show="overlayShow" rounded="sm">
          <div class="p-3">
            <!--<div class="col-sm-12 p-3" v-if="!isReDrawMemoImage">-->
            <!--  <span>以下の商品でよろしければ、決定ボタンを押してください。</span>-->
            <!--</div>-->
            <div class="m-0">
              <div v-show="!showCanvas">
                <ProductSelectionSlider :projectImages="projectImages" :routeProjectType="routeProjectType" :showBookmarkIcon="showBookmarkIcon" @sendSignaling="sliderSendSignaling" @checkImageNumber="checkImageNumber" @checkBookmark="checkBookmark"/>
                <div class="p-3 row mt-2 pr-0">
                  <div class="col-4 col-sm-4 col-lg-5 text-right" v-if="!isReDrawMemoImage && loginStatus['prodInst'] !== '1' && loginStatus['referenceFlag'] !== '1'">
                    <b-button v-if="currentProjectType !== '持ち帰り' && showBookmarkIcon" :variant="allowBookmark ? 'primary' : 'secondary'" :class="allowBookmark ? 'main-button-color' : ''" id="selectProject" @click="registBookmark" :disabled="!allowBookmark">{{allowBookmark ? 'ブックマーク' : 'ブックマーク済み'}}</b-button>
                  </div>
                  <div :class="!(isReDrawMemoImage && allowDrawing) && getIsSelectScreen() ? 'col-4 col-sm-4 col-lg-2 text-center p-0' : 'col-12 col-sm-12 text-center'" v-if="loginStatus['prodInst'] !== '1' && loginStatus['referenceFlag'] !== '1'">
                    <b-button :variant="allowDrawing ? 'success' : 'secondary'" class="px-2" @click="openCanvas" v-show="!showCanvas" :disabled="!allowDrawing">{{allowDrawing ? '手描きする' : '手描き不可'}}</b-button>
                  </div>
                  <div class="col-4 col-sm-4 col-lg-5 text-left" v-if="!isReDrawMemoImage && loginStatus['prodInst'] !== '1' && loginStatus['referenceFlag'] !== '1'">
                    <b-button variant="primary" class="main-button-color" id="selectProject" @click="registProject(slotProps.itemInfoChanged)" v-if="!isSelectComplete">{{isMainGuest ? 'スペック決定' : '商品決定'}}</b-button>
                  </div>
                </div>
                <div class="p-3 row mb-3 pr-0">
                  <div class="col-4 col-sm-4 col-lg-5 text-left" v-if="!(isReDrawMemoImage && allowDrawing) && getIsSelectScreen() && fromBookmark !== 'true'">
                    <b-button variant="outline-primary" class="sub-button-color" id="back" @click="backPage">&lt;&nbsp;戻る</b-button>
                  </div>
                </div>
                <div v-if="isReDrawMemoImage && allowDrawing && currentProjectType != 'ブックマーク'" id="memo">
                  <div v-if="isMainGuest || isMainOptOther || isGuestOptOther">
                    <b-form-group v-if="isMainGuest || isMainOptOther">
                      <label class="mt-3" for="main-table-memo">メインテーブルのメモ欄<span class="ml-2 note-small">※最大1000文字まで入力できます。</span></label>
                      <b-form-textarea name="mainTableMemo" rows="3" max-rows="21" maxlength="1021" v-model="memo['mainTableMemo']"></b-form-textarea>
                    </b-form-group>
                    <b-form-group v-if="isMainGuest || isGuestOptOther">
                      <label class="mt-3" for="guest-table-memo">ゲストテーブルのメモ欄<span class="ml-2 note-small">※最大1000文字まで入力できます。</span></label>
                      <b-form-textarea name="guestTableMemo" rows="3" max-rows="21" maxlength="1021" v-model="memo['guestTableMemo']"></b-form-textarea>
                    </b-form-group>
                  </div>
                  <!--<div v-if="!isMainGuest">-->
                  <div v-else>
                    <b-form-group>
                      <label class="mt-3" for="memo">{{currentProjectType}}のメモ欄<span class="ml-2 note-small">※最大1000文字まで入力できます。</span></label>
                      <b-form-textarea name="itemMemo" rows="3" max-rows="21" maxlength="1021" v-model="memo['itemMemo']" :disabled="!itemMemoInput"></b-form-textarea>
                    </b-form-group>
                  </div>
                  <div class="p-3 row mt-2 mb-3 pr-0">
                    <div class="col-4 col-sm-4 col-lg-5 text-right" v-if="getIsSelectScreen() && fromBookmark !== 'true'">
                      <b-button variant="outline-primary" class="sub-button-color" id="back" @click="backPage">&lt;&nbsp;戻る</b-button>
                    </div>
                    <div class="col-4 col-sm-4 col-lg-2 text-center p-0">
                      <b-button variant="primary" class="main-button-color" @click="savelargeSectionMemo" :disabled="loginStatus['referenceFlag'] === '1'">メモを保存</b-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-3 row mt-2 mb-3 pr-0" v-show="showCanvas">
                <ImageDrawCanvas
                  :memoBackGroundImage="memoBackGroundImage"
                  :memoBackGroundImageWidth="memoBackGroundImageWidth"
                  :memoBackGroundImageHeight="memoBackGroundImageHeight"
                  :drawMode="drawMode"
                  :penColor="penColor"
                  :lineWidth="lineWidth"
                  @registDrawnImage="registDrawnImage"
                  @updateBase64Data="updateBase64Data"
                  ref="imageDrawCanvas"
                />
                <div class="form-row col-sm-12 mt-3 mb-3">
                  <div class="form-group col-lg-2 col-sm-3 mr-2">
                    <label class="mb-0 small" for="penColor">ペンカラー</label>
                    <input class="w-100 mt-1" type="color" list @change="changePenColor" v-model="penColor" name="penColor" id="penColor">
                  </div>
                  <div class="form-group col-lg-2 col-sm-3 ml-2">
                    <label class="mb-0 small" for="drawMode">モード</label>
                    <select class="w-100 mt-1" v-model="drawMode" name="drawMode" id="drawMode">
                      <option value="source-over" selected>ペン</option>
                      <option value="destination-out">消しゴム</option>
                    </select>
                  </div>
                  <div class="form-group col-lg-2 col-sm-3 ml-2">
                    <label class="mb-0 small" for="lineWidth">太さ</label>
                    <select class="w-100 mt-1" v-model="lineWidth" name="lineWidth" id="lineWidth">
                      <option value="2" selected>2px</option>
                      <option value="6">6px</option>
                      <option value="10">10px</option>
                      <option value="30">30px</option>
                      <option value="50">50px</option>
                      <option value="100">100px</option>
                      <option value="200">200px</option>
                      <option value="300">300px</option>
                    </select>
                  </div>
                  <div class="text-right form-group col-lg-2 col-sm-3 mr-2">
                   <b-button variant="outline-secondary" class="mt-4" style="font-size:75%" @click="clearCanvas">クリア</b-button>
                  </div>
                  <div class="form-group col-lg-2 col-sm-3">
                   <b-button variant="outline-secondary" class="mt-4" style="font-size:75%" @click="allClearCanvas">オールクリア</b-button>
                  </div>
                </div>
                <div class="col-sm-12 text-right">
                  <p id="auto-hide-text" class="h3 mr-5 font-weight-bold" v-if="showMemoImageSuccess">反映されました</p>
                  <b-button variant="primary" class="ml-3 main-button-color" @click="registImage">お客様に見せる</b-button>
                  <b-button variant="outline-secondary" class="ml-3" @click="closeCanvas">{{isReDrawMemoImage ? '手描き終了' : '手描き終了'}}</b-button>
                </div>
              </div>
            </div>
            <div id="operationInvalidOverlay" v-if="operationInvalidOverlay">
            </div>
          </div>
        </b-overlay>
      </div>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
    <CommonModal ref="commonModalRegist" @confirmYes="selectProject" />
    <CommonModal ref="commonModalDrawnImageRegist" @confirmYes="exportDrawnImage" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import MeetingLayout from '@/layout/MeetingLayout'
import ProductSelectionSlider from '@/components/ProductSelectionSlider'
import CommonModal from '@/components/CommonModal'
import ImageDrawCanvas from '@/components/ImageDrawCanvas'
import ProductModel from '@/models/ProductModel'
import ProjectDetailModel from '@/models/ProjectDetailModel'
import MemoImageRegistModel from '@/models/MemoImageRegistModel'
import MemoModel from '@/models/MemoModel'
import MemoRegistModel from '@/models/MemoRegistModel'
import SignalingModel from '@/models/SignalingModel'
import MeetingInfoUpdateModel from '@/models/MeetingInfoUpdateModel'
import CategoryListModel from '@/models/CategoryListModel'
import CommonLogModel from '@/models/CommonLogModel'
import RegistBookmarkModel from '@/models/RegistBookmarkModel'
import mstore from '@/store/meeting-store'
import fstore from '@/store/florist-store'

export default {
  name: 'FloristMeetingProductSelection',
  components: { CommonLayout, MeetingLayout, ProductSelectionSlider, CommonModal, ImageDrawCanvas, CategoryListModel },
  data () {
    return {
      overlayShow: false,
      isSelectComplete: false,
      isSendFirstSignalingData: false,
      operationInvalidOverlay: true,
      nextProjectType: '',
      allowDrawing: true,
      showCanvas: false,
      itemMemoInput: true,
      memoBackGroundImage: '',
      memoBackGroundImageWidth: 0,
      memoBackGroundImageHeight: 0,
      memoBackGroundImageNumber: '',
      memoBackGroundFileName: '',
      penColor: '#000000',
      drawMode: 'source-over',
      lineWidth: '2',
      projectImages: {},
      itemInfo: [],
      isMainGuest: false,
      isMainOptOther: false,
      isGuestOptOther: false,
      isReDrawMemoImage: false,
      currentProjectType: '',
      currentTableRowId: '',
      suggestionType: '',
      memo: {'mainTableMemo': '', 'guestTableMemo': '', 'itemMemo': ''},
      showMemoImageSuccess: false,
      prevEvent: '',
      loginStatus: '',
      styleSetSuggestionType: {'cordinate': '', 'main': '', 'guest': ''},
      originalImage: '',
      storageProjectType: '',
      storageSuggestionType: '',
      routeProjectType: '',
      routeTableRowId: '',
      routeSuggestionType: '',
      routeId: '',
      serialNo: '',
      mainOtherRecordNo: '',
      guestOtherRecordNo: '',
      fromBookmark: false,
      allowBookmark: true,
      showBookmarkIcon: false,
      projectNumberForBookmark: '',
      categoryForBookmark: ''
    }
  },
  props: {
    'suggestionTypee': String
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },
    getIsOperationPossible () {
      return fstore.getters.isOperationPossible
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true

        // 接続確立しmeetingSessionが確立した後に要求を送る
        if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
          // 画面リロード時に情報の再送要求
          SignalingModel.sendAgainEvent()
        }
      }
    },
    getSignalingData: function (newData, oldData) {
      try {
        newData['user'] = 'florist'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })
        if (newData['event'] === 'again') {
          SignalingModel.sendClickEvent(this.prevEvent, this)
          return null
        }
        if ('current_path' in newData && oldData) {
          const synchPass = newData['current_path'].replace('customer', 'florist')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (newData['event'] === 'click') {
          if (newData['id'] === 'back') {
            this.$router.push(newData['target_path'])
          } else if (newData['id'] === 'selectProject') {
            this.registProject()
          } else {
            let elm = document.getElementById(newData['id'])
            if (elm !== null) elm.click()
          }
        }

        if (newData['event'] === 'status') {
          if (newData['data']['show_memo_image'] === 'success') {
            // カスタマー側に手描き画像が表示されたらフローリスト側にテキストを表示する
            this.showMemoImageSuccess = true
            setTimeout(() => {
              this.showMemoImageSuccess = false
            }, 5000)
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    getIsOperationPossible: function (bool) {
      if (bool) {
        this.operationInvalidOverlay = false
      } else {
        this.operationInvalidOverlay = true
      }
    }
  },
  methods: {
    setProjectImages () {
      try {
        const store = ProjectDetailModel.getStore()
        if (!store) {
          return null
        }
        // 表示する画像をセットする前に初期化
        this.projectImages = {}
        this.memoBackGroundImage = ''
        let type2 = {'imageNumber': '', 'imagePath': '', 'originalImagePath': ''}
        let type3 = {'imageNumber': '', 'imagePath': '', 'originalImagePath': ''}
        // let type4 = {'imageNumber': '', 'imagePath': '', 'originalImagePath': ''}
        for (var index of Object.keys(store.projects.images)) {
          this.$set(this.projectImages, index, store.projects.images[index])
          if (this.projectImages[index]['imageNumber'] === '2') {
            type2 = this.projectImages[index]
          }
          if (this.projectImages[index]['imageNumber'] === '3') {
            type3 = this.projectImages[index]
          }
          // if (this.projectImages[index]['imageNumber'] === '4') {
          //   type4 = this.projectImages[index]
          // }
        }
        if (this.suggestionType === 'main') {
          this.projectImages = {
            0: type2
          }
        }
        if (this.suggestionType === 'guest') {
          this.projectImages = {
            0: type3
            // 1: type4
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    setItemInfo () {
      try {
        const store = ProjectDetailModel.getStore()
        if (!store) {
          return null
        }
        this.itemInfo = store.projects.itemInfo
        if ('serialNo' in store) {
          this.serialNo = store.serialNo
        }
        if ('mainOtherRecordNo' in store) {
          this.mainOtherRecordNo = store.mainOtherRecordNo
        }
        if ('guestOtherRecordNo' in store) {
          this.guestOtherRecordNo = store.guestOtherRecordNo
        }
        if ('projectNumberForBookmark' in store.projects && this.routeProjectType === 'ブックマーク') {
          this.projectNumberForBookmark = store.projects.projectNumberForBookmark
        }
        if ('category' in store.projects && this.routeProjectType === 'ブックマーク') {
          this.categoryForBookmark = store.projects.category
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sliderSendSignaling (id) {
      try {
        console.log(this.prevEvent, id)
        if (id !== this.prevEvent) {
          this.prevEvent = id
          if (fstore.getters.isOperationPossible) {
            SignalingModel.sendClickEvent(id, this)
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    setApiData: async function () {
      try {
        this.overlayShow = true

        if (localStorage.getItem('suggestionData') === null) {
          return this.$refs.commonModal.msgBoxOk('提案条件を設定してください')
        }

        this.routeProjectType = this.$route.query.projectType
        this.routeTableRowId = this.$route.query.tableRowId
        this.routeId = this.$route.params.id
        this.routeSuggestionType = this.$route.query.suggestionType
        this.fromBookmark = this.$route.query.fromBookmark
        if (JSON.parse(localStorage.getItem('suggestionData'))['projectType']) {
          this.storageProjectType = JSON.parse(localStorage.getItem('suggestionData')).projectType[0]
        }
        if (JSON.parse(localStorage.getItem('suggestionData'))['suggestionType']) {
          this.storageSuggestionType = JSON.parse(localStorage.getItem('suggestionData')).suggestionType[0]
        }

        this.isReDrawMemoImage = !(await this.getIsSelectScreen())
        this.currentProjectType = this.routeProjectType !== undefined ? this.routeProjectType : this.storageProjectType
        this.suggestionType = this.routeSuggestionType !== undefined ? this.routeSuggestionType : this.storageSuggestionType

        this.isMainGuest = this.consts.projectType.main.indexOf(this.currentProjectType) !== -1
        // 初期化
        this.isMainOptOther = false
        this.isGuestOptOther = false
        // suggestionTypeに応じて各種フラグを切り替え
        if (this.suggestionType === 'mainopt' || this.suggestionType === 'main') {
          this.isMainGuest = false
          this.isMainOptOther = true
          this.isGuestOptOther = false
        } else if (this.suggestionType === 'guestopt' || this.suggestionType === 'guest') {
          this.isMainGuest = false
          this.isMainOptOther = false
          this.isGuestOptOther = true
        }
        if (this.routeTableRowId) {
          this.currentTableRowId = this.routeTableRowId
        }
        let params = {
          'projectType': this.currentProjectType,
          'suggestionType': this.suggestionType,
          'isSelected': this.isReDrawMemoImage ? 'True' : 'False',
          'tableRowId': this.currentTableRowId
        }
        await ProjectDetailModel.apiSetStore(this.$bvModal, this.routeId, params, () => {
          this.overlayShow = false
        })
        this.setProjectImages()
        this.setItemInfo()

        // 見積非表示商品の情報を取得
        await CategoryListModel.apiSetStore(this.$bvModal, {'hihyoji': '非表示にする'}, () => {})
        console.log(CategoryListModel.getStore())

        // itemInfoを参照
        this.itemMemoInput = true
        if (Object.keys(this.itemInfo).length > 0) {
          // 大区分が内部の商品カテゴリと異なっていたら、大区分を優先する。
          if (this.itemInfo[Object.keys(this.itemInfo)[0]][0]['sectionL'] !== this.currentProjectType &&
            !((this.itemInfo[Object.keys(this.itemInfo)[0]][0]['sectionL'] === 'メインテーブル' ||
              this.itemInfo[Object.keys(this.itemInfo)[0]][0]['sectionL'] === 'ゲストテーブル') &&
              this.currentProjectType === 'メインテーブル・ゲストテーブル')) {
            console.log('大区分が内部の商品カテゴリと異なっていたら、大区分を優先する。')
            this.currentProjectType = this.itemInfo[Object.keys(this.itemInfo)[0]][0]['sectionL']
          }
          // 見積非表示カテゴリのときはメモを非活性とする
          let hiddenCategoryList = CategoryListModel.getStore()
          for (const hiddenCategory of hiddenCategoryList['records']) {
            if (this.itemInfo[Object.keys(this.itemInfo)[0]][0]['sectionL'] === hiddenCategory['大分類']['value'] &&
              this.itemInfo[Object.keys(this.itemInfo)[0]][0]['sectionM'] === hiddenCategory['中分類']['value'] &&
              this.itemInfo[Object.keys(this.itemInfo)[0]][0]['sectionS'] === hiddenCategory['小分類']['value']) {
              this.itemMemoInput = false
              this.showBookmarkIcon = false
              break
            }
            this.showBookmarkIcon = true
          }
        }

        if (this.isReDrawMemoImage) {
          if (this.currentProjectType !== 'ブックマーク') {
            params['memoType'] = ['large_section']
            const memo = await MemoModel.apiSetStore(this.$bvModal, params, () => {})
            for (const memoType of Object.keys(memo.largeSectionMemo)) {
              this.$set(this.memo, memoType, memo.largeSectionMemo[memoType])
            }
          }
          SignalingModel.sendClickEvent('reDrawMemoImage', this, {'projectNumber': this.routeId, 'projectType': this.currentProjectType, 'suggestionType': this.suggestionType, 'tableRowId': this.currentTableRowId})
        }

        if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
          if (!this.isReDrawMemoImage) {
            this.sendSignalingApiData()
          }
          this.isSendFirstSignalingData = true
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendSignalingApiData: async function () {
      try {
        const store = ProjectDetailModel.getStore()
        if (!store) {
          return null
        }
        let apiRes = {}
        apiRes = {
          'status': store.status,
          'message': store.message
          // 'images': store.projects.images
        }
        SignalingModel.sendApiEvent('getProjectDetail', this, apiRes)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return null
      }
    },
    registImage: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      if (this.routeProjectType !== this.$route.query.projectType ||
        this.routeTableRowId !== this.$route.query.tableRowId ||
        this.routeId !== this.$route.params.id) {
        this.$refs.commonModalDrawnImageRegist.msgBoxYesNo('URLに不整合が起こっています。ブラウザバックが行われた可能性があります。\nエラーが発生する可能性があります。\n手書き画像登録を実行しますか？')
      } else if (((this.currentProjectType !== this.storageProjectType && (this.currentProjectType !== 'お客様画像' && this.currentProjectType !== 'ブックマーク')) ||
        this.suggestionType !== this.storageSuggestionType) &&
        !this.$route.query.tableRowId && this.fromBookmark !== 'true') {
        this.$refs.commonModalDrawnImageRegist.msgBoxYesNo('ブラウザバックが行われた可能性があります。\nエラーが発生する可能性がありますが、手書き画像登録を実行しますか？\n推奨：再度商品検索・手書き画像登録をしてください。')
      } else {
        this.exportDrawnImage()
      }
    },
    registProject: async function (itemInfo) {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      if (this.routeProjectType !== this.$route.query.projectType ||
        this.routeTableRowId !== this.$route.query.tableRowId ||
        this.routeId !== this.$route.params.id) {
        this.$refs.commonModalRegist.msgBoxYesNo('URLに不整合が起こっています。ブラウザバックが行われた可能性があります。\nエラーが発生する可能性があります。\n商品登録を実行しますか？', itemInfo)
      } else if (((this.currentProjectType !== this.storageProjectType && (this.currentProjectType !== 'お客様画像' && this.currentProjectType !== 'ブックマーク')) ||
        this.suggestionType !== this.storageSuggestionType) &&
        !this.$route.query.tableRowId && this.fromBookmark !== 'true') {
        this.$refs.commonModalRegist.msgBoxYesNo('ブラウザバックが行われた可能性があります。\nエラーが発生する可能性がありますが、商品決定を実行しますか？\n推奨：再度商品検索・決定をしてください。', itemInfo)
      } else {
        this.selectProject(itemInfo)
      }
    },
    selectProject: async function (itemInfo) {
      try {
        this.overlayShow = true
        const params = {
          'selectedProjectType': this.currentProjectType,
          'selectedProjectNumber': this.routeId,
          'suggestionType': this.suggestionType
        }
        if ((this.suggestionType) in this.styleSetSuggestionType) {
          let selectedMainItems = []
          let selectedGuestItems = []
          if ('メインテーブル' in itemInfo) {
            selectedMainItems = itemInfo['メインテーブル'].filter(o => o.checked)
          }
          if ('ゲストテーブル' in itemInfo) {
            selectedGuestItems = itemInfo['ゲストテーブル'].filter(o => o.checked)
          }

          if (selectedMainItems.length === 0 && selectedGuestItems.length === 0) {
            this.overlayShow = false
            return this.$refs.commonModal.msgBoxOk('提案する商品を選択してください')
          }
          for (const selectedMainItem of selectedMainItems) {
            if (selectedMainItem.itemPriceRaw === '') {
              this.overlayShow = false
              return this.$refs.commonModal.msgBoxOk('メインテーブルの商品の価格を入力してください')
            } else {
              if (this.isNumeric(selectedMainItem.itemPriceRaw) === false) {
                this.overlayShow = false
                return this.$refs.commonModal.msgBoxOk('メインテーブルの商品の価格は0以上の数値で入力してください')
              }
              // else if (Number(selectedMainItem.itemPriceRaw) < 0) {
              //   this.overlayShow = false
              //   return this.$refs.commonModal.msgBoxOk('メインテーブルの商品の価格は0以上の数値で入力してください')
              // }
            }
            if (selectedMainItem.quantity === '') {
              this.overlayShow = false
              return this.$refs.commonModal.msgBoxOk('メインテーブルの商品の数量を入力してください')
            } else {
              if (this.isDecimal(selectedMainItem.quantity) === false) {
                this.overlayShow = false
                return this.$refs.commonModal.msgBoxOk('メインテーブルの商品の数量は0.00以上の数値で入力してください')
              } else if (Number(selectedMainItem.quantity) < 0) {
                this.overlayShow = false
                return this.$refs.commonModal.msgBoxOk('メインテーブルの商品の数量は0.00以上の数値で入力してください')
              }
            }
          }
          for (const selectedGuestItem of selectedGuestItems) {
            if (selectedGuestItem.itemPriceRaw === '') {
              this.overlayShow = false
              return this.$refs.commonModal.msgBoxOk('ゲストテーブルの商品の価格を入力してください')
            } else {
              if (this.isNumeric(selectedGuestItem.itemPriceRaw) === false) {
                this.overlayShow = false
                return this.$refs.commonModal.msgBoxOk('ゲストテーブルの商品の価格は0以上の数値で入力してください')
              }
              // else if (Number(selectedGuestItem.itemPriceRaw) < 0) {
              //   this.overlayShow = false
              //   return this.$refs.commonModal.msgBoxOk('ゲストテーブルの商品の価格は0以上の数値で入力してください')
              // }
            }
            if (selectedGuestItem.quantity === '') {
              this.overlayShow = false
              return this.$refs.commonModal.msgBoxOk('ゲストテーブルの商品の数量を入力してください')
            } else {
              if (this.isDecimal(selectedGuestItem.quantity) === false) {
                this.overlayShow = false
                return this.$refs.commonModal.msgBoxOk('ゲストテーブルの商品の数量は0.00以上の数値で入力してください')
              } else if (Number(selectedGuestItem.quantity) < 0) {
                this.overlayShow = false
                return this.$refs.commonModal.msgBoxOk('ゲストテーブルの商品の数量は0.00以上の数値で入力してください')
              }
            }
          }
          params['selectedMainItems'] = selectedMainItems
          params['selectedGuestItems'] = selectedGuestItems
        } else {
          let selectedItems = []
          selectedItems = itemInfo[Object.keys(itemInfo)[0]]

          for (const selectedItem of selectedItems) {
            if (selectedItem.itemPriceRaw === '') {
              this.overlayShow = false
              return this.$refs.commonModal.msgBoxOk('商品の価格を入力してください')
            } else {
              if (this.isNumeric(selectedItem.itemPriceRaw) === false) {
                this.overlayShow = false
                return this.$refs.commonModal.msgBoxOk('商品の価格は0以上の数値で入力してください')
              }
              // else if (Number(selectedItem.itemPriceRaw) < 0) {
              //   this.overlayShow = false
              //   return this.$refs.commonModal.msgBoxOk('商品の価格は0以上の数値で入力してください')
              // }
            }
            if (selectedItem.quantity === '') {
              this.overlayShow = false
              return this.$refs.commonModal.msgBoxOk('商品の数量を入力してください')
            } else {
              if (this.isDecimal(selectedItem.quantity) === false) {
                this.overlayShow = false
                return this.$refs.commonModal.msgBoxOk('商品の数量は0.00以上の数値で入力してください')
              } else if (Number(selectedItem.quantity) < 0) {
                this.overlayShow = false
                return this.$refs.commonModal.msgBoxOk('商品の数量は0.00以上の数値で入力してください')
              }
            }
          }
          params['selectedItems'] = selectedItems
        }
        const response = await ProductModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        console.log('selectProjectのresponse↓')
        console.log(response)
        if ('id' in response) {
          this.currentTableRowId = response['id']
        }
        if ('serialNo' in response) {
          this.serialNo = response['serialNo']
        }
        if ('mainOtherRecordNo' in response) {
          this.mainOtherRecordNo = response['mainOtherRecordNo']
        }
        if ('guestOtherRecordNo' in response) {
          this.guestOtherRecordNo = response['guestOtherRecordNo']
        }

        SignalingModel.sendClickEvent('selectProject', this)
        this.isSelectComplete = true
        this.isReDrawMemoImage = true
        // itemInfoを参照して、見積非表示カテゴリのときはメモを非活性とする。
        this.itemMemoInput = true
        let hiddenCategoryList = CategoryListModel.getStore()
        console.log(hiddenCategoryList)
        for (const hiddenCategory of hiddenCategoryList['records']) {
          if (itemInfo[Object.keys(itemInfo)[0]][0]['sectionL'] === hiddenCategory['大分類']['value'] &&
            itemInfo[Object.keys(itemInfo)[0]][0]['sectionM'] === hiddenCategory['中分類']['value'] &&
            itemInfo[Object.keys(itemInfo)[0]][0]['sectionS'] === hiddenCategory['小分類']['value']) {
            this.itemMemoInput = false
            this.showBookmarkIcon = false
            break
          }
          this.showBookmarkIcon = true
        }
        fstore.commit('setIsFirstGetHeaderEstimate', true)
        this.$refs.commonModal.msgBoxOk('商品選択が完了しました')
        if (!this.consts.projectType.noDrawing.includes(this.currentProjectType)) {
          let memoParams = {
            'projectType': this.currentProjectType,
            'suggestionType': this.suggestionType,
            'isSelected': this.isReDrawMemoImage ? 'True' : 'False',
            'tableRowId': this.currentTableRowId,
            'memoType': 'large_section'
          }
          console.log(memoParams)
          const memo = await MemoModel.apiSetStore(this.$bvModal, memoParams, () => {})
          for (const memoType of Object.keys(memo.largeSectionMemo)) {
            this.$set(this.memo, memoType, memo.largeSectionMemo[memoType])
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    backPage () {
      try {
        const targetPath = '/florist/meeting/product_proposal'
        SignalingModel.sendClickEvent('back', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    checkImageNumber () {
      try {
        const sliderMainImage = document.getElementsByClassName('slick-current')[0].querySelectorAll('img')
        if (this.consts.projectType.main.indexOf(this.currentProjectType) !== -1 && ['mainopt', 'guestopt'].includes(this.suggestionType) === false) {
          const allowDrawingImageNumbers = ['1', '2', '3', '4', '5']
          this.allowDrawing = allowDrawingImageNumbers.includes(sliderMainImage[0].dataset.imageNumber)
        } else if (this.consts.projectType.noDrawing.includes(this.currentProjectType)) {
          // 手描きをしないカテゴリ(大区分)の場合に、手描きできないようにフラグをセット
          this.allowDrawing = false
        } else {
          this.allowDrawing = sliderMainImage[0].dataset.imageNumber === '0' || this.currentProjectType === 'ブックマーク'
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    checkBookmark () {
      try {
        const sliderMainImage = document.getElementsByClassName('slick-current')[0].querySelectorAll('img')
        this.allowBookmark = !sliderMainImage[0].dataset.bookmark
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    openCanvas () {
      try {
        const sliderMainImage = document.getElementsByClassName('slick-current')[0].querySelectorAll('img')
        for (let i in this.projectImages) {
          if (this.projectImages[i]['imagePath'] === sliderMainImage[0].src) {
            this.originalImage = this.projectImages[i]['originalImagePath']
          }
        }
        this.memoBackGroundImage = sliderMainImage[0].src
        this.memoBackGroundImageNumber = sliderMainImage[0].dataset.imageNumber
        this.memoBackGroundFileName = sliderMainImage[0].dataset.fileName
        const maxWidth = sliderMainImage[0].clientWidth
        const maxHeight = sliderMainImage[0].clientHeight
        if (sliderMainImage[0].naturalWidth > maxWidth || sliderMainImage[0].naturalHeight > maxHeight) {
          // アスペクト比計算
          const w = sliderMainImage[0].naturalWidth
          const h = sliderMainImage[0].naturalHeight
          const g = this.gcd(w, h)
          const ratioW = w / g
          const ratioH = h / g
          if (ratioW > ratioH) {
            // 横長画像(横幅 > 高さ)の場合
            this.memoBackGroundImageWidth = maxWidth
            this.memoBackGroundImageHeight = (maxWidth / ratioW) * ratioH
          } else {
            // 縦長画像(横幅 < 高さ)の場合
            this.memoBackGroundImageHeight = maxHeight
            this.memoBackGroundImageWidth = (maxHeight / ratioH) * ratioW
          }
        } else {
          this.memoBackGroundImageWidth = sliderMainImage[0].naturalWidth
          this.memoBackGroundImageHeight = sliderMainImage[0].naturalHeight
        }
        this.showCanvas = true
        if (sliderMainImage[0].src.length >= 2048) {
          SignalingModel.sendClickEvent('openCanvas', this, {'projectType': this.currentProjectType, 'imageNumber': this.memoBackGroundImageNumber, 'tableRowId': this.currentTableRowId})
        } else {
          SignalingModel.sendClickEvent('openCanvas', this, {'memoImageSrc': this.memoBackGroundImage, 'tableRowId': this.currentTableRowId})
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    isNumeric (val) {
      return /^-?\d+$/.test(val)
    },
    isDecimal (val) {
      return new RegExp(/^([1-9]\d*|0)(\.\d{1,2})?$/).test(val)
    },
    gcd (x, y) {
      try {
        if (y === 0) {
          return x
        }
        return this.gcd(y, x % y)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    closeCanvas () {
      try {
        this.showCanvas = false
        SignalingModel.sendClickEvent('closeCanvas', this)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    exportDrawnImage () {
      try {
        this.$refs.imageDrawCanvas.onExportDrawnImage()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    changePenColor (e) {
      try {
        this.penColor = e.target.value
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    registDrawnImage: async function (dataURL) {
      try {
        this.overlayShow = true
        for (const [index, value] of Object.entries(this.projectImages)) {
          if (value.imageNumber === this.memoBackGroundImageNumber) {
            value.imagePath = dataURL
            this.$set(this.projectImages, index, value)
          }
        }
        const params = {
          'memoImage': dataURL.replace(/^.*,/, ''),
          'projectType': this.currentProjectType,
          'suggestionType': this.suggestionType,
          'imageNumber': this.memoBackGroundImageNumber,
          'itemCode': this.routeId,
          'isTmp': this.isReDrawMemoImage ? 0 : 1,
          'tableRowId': this.currentTableRowId,
          'serialNo': this.serialNo,
          'mainOtherRecordNo': this.mainOtherRecordNo,
          'guestOtherRecordNo': this.guestOtherRecordNo,
          'projectNumberForBookmark': this.projectNumberForBookmark,
          'categoryForBookmark': this.categoryForBookmark,
          'fileName': this.memoBackGroundFileName
        }
        console.log(params)
        await MemoImageRegistModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        SignalingModel.sendClickEvent('showMemoImage', this, {'projectType': this.currentProjectType, 'imageNumber': this.memoBackGroundImageNumber, 'tableRowId': this.currentTableRowId})
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    reDrawMemoImage: async function () {
      try {
        console.log('reDrawMemoImage')
        this.showCanvas = false
        this.isReDrawMemoImage = true

        // setApiData内部で'reDrawMemoImage'のsendClickEventを流してからほかのsendClickEventを流さなければならない。
        // そうしないとcurrent_pathが異なるため、その画面に遷移してしまう。
        await this.setApiData()

        fstore.commit('setIsOperationPossible', true)
        SignalingModel.sendClickEvent('operationInvalid', this)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    savelargeSectionMemo: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      try {
        this.overlayShow = true
        let registData = {}
        const memo = document.getElementById('memo').getElementsByTagName('textarea')
        for (const key of Object.keys(memo)) {
          registData[memo[key].name] = memo[key].value
        }
        const params = {
          'largeSectionMemo': registData,
          'projectType': this.currentProjectType,
          'isMainMemo': this.isMainGuest || this.isMainOptOther,
          'isGuestMemo': this.isMainGuest || this.isGuestOptOther
        }
        await MemoRegistModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    getIsSelectScreen () {
      if ((this.routeProjectType !== 'お客様画像' && this.routeProjectType !== 'ブックマーク') && this.routeTableRowId === undefined) {
        return true
      }
      return false
    },
    clearCanvas () {
      try {
        this.$refs.imageDrawCanvas.clearCanvas()
        SignalingModel.sendClickEvent('clearCanvas', this)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    allClearCanvas () {
      let result = window.confirm('過去に保存した手描き線も全てクリアされます。宜しいですか？')
      if (result) {
        this.memoBackGroundImage = this.originalImage
        this.clearCanvas()
      }
    },
    registBookmark: async function () {
      try {
        this.overlayShow = true
        const sliderMainImage = document.getElementsByClassName('slick-current')[0].querySelectorAll('img')
        const imageNumber = sliderMainImage[0].dataset.imageNumber
        const params = {
          'selectedProjectType': this.currentProjectType,
          'selectedProjectNumber': this.routeId,
          'suggestionType': this.suggestionType,
          'imageNumber': imageNumber,
          'itemCode': this.routeId
        }
        const response = await RegistBookmarkModel.apiSetStore(this.$bvModal, params, async () => {
          this.overlayShow = false
        })
        for (let i in this.projectImages) {
          if (this.projectImages[i]['imageNumber'] === imageNumber) {
            this.projectImages[i]['bookmark'] = true
            this.projectImages[i]['fileName'] = response['fileName']
            this.allowBookmark = false
            break
          }
        }
        SignalingModel.sendClickEvent('registBookmark', this, {'imageNumber': imageNumber})
        console.log(response)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  mounted () {
    try {
      this.setApiData()
      // お客様画像の手描き画面表示とブックマーク画面表示の場合、フローリスト操作中を初期状態とする
      if (this.routeProjectType && (this.routeProjectType === 'お客様画像' || this.routeProjectType === 'ブックマーク') &&
        sessionStorage.getItem('lastRoutePath') !== this.$route.path
      ) {
        fstore.commit('setIsOperationPossible', true)

        // 権限の情報をdynamoDBに登録
        const updateData = {
          'operatingPrivilege': '0',
          'attendeeType': this.consts.attendeeType.florist
        }
        MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})
      }
      if (fstore.getters.isOperationPossible) {
        this.operationInvalidOverlay = false
      }
      this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  },
  destroyed () {
    try {
      if (ProjectDetailModel.getStore()) {
        ProjectDetailModel.removeStore()
      }
      if (MemoImageRegistModel.getStore()) {
        MemoImageRegistModel.removeStore()
      }
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  }
}
</script>
<style scoped type="text/css">
.slick-next, .slick-prev, .slick-dots li, .slick-track {
  pointer-events: none;
}
#operationInvalidOverlay{
  position: absolute;
  left: 0; top: 0;
  width: 100%; height: 100%;
  opacity: 0;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/pages/FloristMeetingProductSelection.vue